import { render } from "./MarketingPromptDialog.vue?vue&type=template&id=4063c67c"
import script from "./MarketingPromptDialog.vue?vue&type=script&lang=js"
export * from "./MarketingPromptDialog.vue?vue&type=script&lang=js"

import "./MarketingPromptDialog.vue?vue&type=style&index=0&id=4063c67c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__